import { spacingMixin } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledSection = styled.section`
    ${props => props.theme &&
        props.theme.ns &&
        spacingMixin
}
`;
